/**
 * Aviso explícito de que uma página do fluxo de compra foi CRIADA (ngOnInit).
 *
 * Por que existe (27/09/2026): a tela multissinal descobria que a página de baixo tinha sido
 * recriada com ela aberta (o voltar do Android; varredura de 24/09) por um efeito colateral, o
 * `console.error('not logged')` que o `getCashbackBalance()` deixava órfão no ngOnInit do
 * cardápio, do carrinho e do pagamento. Aquele erro foi corrigido, e o sinal sumiu com ele. Além
 * disso ele só existia para visitante SEM login. Este aviso é o mesmo instante, dito de propósito
 * e para todo mundo.
 *
 * Evento de janela, e não serviço injetado: quem ouve (a tela multissinal) e quem avisa (as
 * páginas) não se conhecem, e o aviso não pode criar dependência de DI entre elas.
 */
export const EVENTO_PAGINA_CRIADA = 'mp:pagina-criada';

export type PaginaDoFluxo = 'cardapio' | 'carrinho' | 'pagamento';

export function avisarPaginaCriada(pagina: PaginaDoFluxo): void {
	try {
		if (typeof window === 'undefined' || typeof CustomEvent !== 'function') return;
		window.dispatchEvent(new CustomEvent(EVENTO_PAGINA_CRIADA, { detail: { pagina } }));
	} catch (e) {
		// telemetria nunca derruba a página
	}
}
